import { useRef } from 'react';

import { RequirementFiltersLoader } from '../loaders/RequirementFiltersLoader';
import { RequirementStudentsLoader } from '../loaders/RequirementStudentsLoader';
import {
  ElectiveRequirementEnrollmentStatus,
  ElectiveRequirementItem,
} from '../types';
import RequirementFilters from './RequirementFilters';
import RequirementResultModal, {
  RequirementResultModalRef,
} from './RequirementResultModal';
import RequirementTable from './RequirementTable';

export default function ElectiveRequirementPanel({
  item,
  enrollmentStatus,
  readOnly,
  hideStatusFilter,
}: {
  item: ElectiveRequirementItem;
  enrollmentStatus: ElectiveRequirementEnrollmentStatus;
  readOnly: boolean;
  hideStatusFilter: boolean;
}) {
  const modalRef = useRef<RequirementResultModalRef>(null);

  return (
    <RequirementFiltersLoader
      defaultQuery={{ typeId: item.typeId, enrollmentStatus }}
      fetchImmediately
    >
      <RequirementStudentsLoader
        defaultQuery={{
          typeId: item.typeId,
          page: 1,
          items_per_page: 10,
          enrollmentStatus,
        }}
        fetchImmediately
      >
        <div className="px-3 pb-4">
          <RequirementFilters
            typeId={item.typeId}
            hideStatusFilter={hideStatusFilter}
          />
          <RequirementTable
            item={item}
            modalRef={modalRef}
            enrollmentStatus={enrollmentStatus}
            readOnly={readOnly}
          />
          <RequirementResultModal ref={modalRef} item={item} />
        </div>
      </RequirementStudentsLoader>
    </RequirementFiltersLoader>
  );
}
